import { cloneDeep, set } from "lodash";
import store from "../../../../../store";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { NotificationManager } from "react-notifications";
import i18n from "../../../../../Utils/i18next/i18next";
import { t } from "i18next";
import moment from "moment";

export const onSubmit = async (values, props) => {
  const { projectReducer } = store.getState();
  const {
    updateTask,
    loadData,
    uuid,
    updateSingleRegistry,
    updateTaskTable,
    initialValues,
  } = props;

  const data = cloneDeep(values);

  // Zaktualizowanie danych zadania
  if (values?.taskAssignee?.value)
    set(data, "taskAssignee.uuid", values?.taskAssignee?.value);

  if (values?.taskPriority?.value)
    set(data, "taskPriority", values?.taskPriority?.value);

  if (values?.taskStatus?.value)
    set(data, "taskStatus", values?.taskStatus?.value);

  let payload;

  // Dodawanie zadania
  if (!updateTask) {
    const res = await GlobalAuthFetch({
      path: `/project/${uuid}/task`, // Używamy UUID projektu w URL
      method: "POST",
      data,
    });
    payload = res.payload;
  }

  // Aktualizacja istniejącego zadania
  if (updateTask) {
    const res = await GlobalAuthFetch({
      path: `/project/${uuid}/task/${data?.uuid}`, // Aktualizujemy konkretne zadanie
      method: "PUT",
      data,
    });
    payload = res.payload;
  }

  // Obsługa błędów odpowiedzi
  if (payload?.status >= 300 || !payload?.status) {
    props.setErrorHeader(0, true);
    return;
  }

  // Brak błędów
  props.setErrorHeader(0, false);

  // Succes nofify
  loadData();
  NotificationManager.success(i18n.t("global:success"));
  if (updateSingleRegistry) updateSingleRegistry();

  props.handleHide();
};

export const onValidate = (values, props) => {
  const errorsStep0 = {};

  if (!values.taskContent) {
    errorsStep0.taskContent = t("global:task.errors.taskContent");
  }

  if (values.taskContent && values.taskContent.length > 100) {
    errorsStep0.taskContent = `${t(
      "global:project.errors.taskContentLength"
    )} (aktualna ilość znaków ${values.taskContent.length}) max. ${100}`;
  }

  if (!values.taskAssignee || values.taskAssignee.length === 0) {
    errorsStep0.taskAssignee = t("global:task.errors.taskAssignee");
  }

  if (values.taskDescription && values.taskDescription.length > 500) {
    errorsStep0.taskDescription = `${t(
      "global:project.errors.taskDescriptionLength"
    )} (aktualna ilość znaków ${values.taskDescription.length}) max. ${500}`;
  }

  // Sprawdzenie czy taskStartDate i taskEndDate są ustawione
  if (values.taskStartDate && values.taskEndDate) {
    const startDate = moment(values.taskStartDate);
    const endDate = moment(values.taskEndDate);

    if (startDate.isAfter(endDate)) {
      errorsStep0.taskStartDate = t("global:task.errors.invalidDateRange");
      errorsStep0.taskEndDate = t("global:task.errors.invalidDateRange");
    }
  }

  if (!values.taskDeadline) {
    errorsStep0.taskDeadline = t("global:task.errors.taskDeadline");
  }

  const hasErrorsStep0 = Object.keys(errorsStep0).length > 0;

  if (props.isSubmit && props.steps[0]?.error !== hasErrorsStep0) {
    props.setErrorHeader(0, hasErrorsStep0);
  }

  return { ...errorsStep0 };
};
